import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
/**
 * One label/value line inside a lib-anc-summary-list. The consumer projects the
 * right-hand side (a computed figure, or a currency-prefixed form input), while
 * this primitive standardises the label, alignment and the two emphasis states
 * that make the breakdown legible:
 *
 * - `readonly`  → computed values (Order Total, Total Amount): plain right-
 *   aligned figure, no input chrome, so "we calculate this" reads at a glance.
 * - `emphasized` → the grand total: bold, with a divider rule above it.
 *
 * Optional validation messages are projected via the `ancSummaryRowError` slot
 * so they render full-width beneath the row.
 */
@Component({
    selector: 'lib-anc-summary-row',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-summary-row.component.html',
    styleUrls: ['./anc-summary-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncSummaryRowComponent {
    /** Left-hand label text (e.g. "Order Total", "Shipping Cost"). */
    label = input<string>('');
    /** Computed value row — renders the value as plain text, no input chrome. */
    readonly = input<boolean>(false);
    /** Grand-total row — bold value with a divider rule above. */
    emphasized = input<boolean>(false);
}
